import { createFile } from '../../api/files'
import InsertImages from 'slate-drop-or-paste-images'

const PastImage = () => {
  return InsertImages({
    extensions: ['png', 'jpg', 'jpeg'],
    applyTransform: (transform, file) => {
      return createFile([file])
        .then(file => {
          return transform.insertInline({
            type: 'image',
            isVoid: true,
            data: { src: file.location, title: file.name, fileId: file.id }
          })
        })
    }
  })
}

export default PastImage



// WEBPACK FOOTER //
// ./src/components/PasteImageSlatePlugin/PasteImageSlatePluginContainer.js